<template>
    <div class="parques">
        <h2 class="subheading grey--text">{{$t('Empresas')}}</h2>
        <v-container class="my-5">
            <!--   Diálogo para Mostrar un mensaje al Activar/Desactivar Empresa    -->
            <v-dialog
                    v-model="dialogEnableDisable"
                    max-width="600"
            >
                <v-card>
                    <v-toolbar dark :color=" enable === true ? 'primary' : 'warning'">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogEnableDisable = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-title class="headline">
                        <div v-if="enable === true">
                            {{$t('msg_enable_main_resident')}}
                        </div>
                        <div v-else-if="disable=== true">
                            {{$t('msg_disable_main_resident')}}
                        </div>
                    </v-card-title>
                    <v-card-text v-if="enable === true">
                        {{$t('note_enable_main_resident')}}
                    </v-card-text>
                    <v-card-text v-else-if="disable === true">
                        {{$t('note_disable_main_resident')}}
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                outlined
                                color="primary"
                                @click="dialogEnableDisable = false"
                        >
                            No
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                outlined
                                color="primary"
                                :loading="loadingEnableDisable"
                                @click="enableDisableCompany()"
                        >
                            {{$t('Si')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--   Diálogo para Mostrar un mensaje al Activar/Desactivar Usuarios Invitaciones de una Empresa    -->
            <v-dialog
                    v-model="dialogEnableDisableInvitation"
                    max-width="600"
            >
                <v-card>
                    <v-toolbar dark :color=" enableInvitation === true ? 'primary' : 'warning'">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogEnableDisableInvitation = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-title class="headline">
                        <div v-if="enableInvitation === true">
                            {{$t('msg_enable_invitation_company')}}
                        </div>
                        <div v-else-if="disableInvitation=== true">
                            {{$t('msg_disable_invitation_company')}}
                        </div>
                    </v-card-title>
                    <v-card-text v-if="enableInvitation === true">
                        {{$t('note_enable_invitation_company')}}
                    </v-card-text>
                    <v-card-text v-else-if="disableInvitation === true">
                        {{$t('note_disable_invitation_company')}}
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                outlined
                                color="primary"
                                @click="dialogEnableDisableInvitation = false"
                        >
                            No
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                outlined
                                color="primary"
                                :loading="loadingEnableDisableInvitation"
                                @click="enableDisableInvitationCompany()"
                        >
                            {{$t('Si')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogReport" max-width="500">
                <v-card>
                    <v-card-title light class="headline primary white--text">
                        {{$t('reportes')}}
                    </v-card-title>
                    <v-card-text>
                        <v-layout class="align-center " row wrap>
                            <v-flex xs12 md6>
                                <v-menu
                                        v-model="calendario2"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                v-model="computedInitialDateFormatted"
                                                prepend-icon="event"
                                                name="date"
                                                :label="$t('Fecha_ini')"
                                                :hint="$t('formato_fecha')"
                                                persistent-hint
                                                readonly
                                                v-on="on"
                                                :error-messages="errores.date"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                            :locale="$t('region')"
                                            v-model="date"
                                            @input="calendario2 = false, submit()">
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 md6>
                                <v-menu
                                        v-model="calendario3"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                v-model="computedFinalDateFormatted"
                                                prepend-icon="event"
                                                name="date2"
                                                :label="$t('Fecha_fin')"
                                                :hint="$t('formato_fecha')"
                                                persistent-hint
                                                readonly
                                                v-on="on"
                                                :error-messages="errores.date2"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                            :locale="$t('region')"
                                            v-model="date2"
                                            @input="calendario3 = false, submit()">
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                        <br>
                        <v-layout class="align-center " row wrap>
                            <v-flex xs12>
                                <v-list subheader>
                                    <v-list-tile avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{$t('headerInvitationSent')}}</v-list-tile-title>
                                        </v-list-tile-content>
                                        <v-list-tile-avatar>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        color="primary"
                                                        dark
                                                        v-on="on"
                                                        icon
                                                        :loading="loadingReportPDF"
                                                        @click="exportPdfInvitationSent">
                                                        <v-icon>picture_as_pdf</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{$t('download_to_pdf')}}</span>
                                            </v-tooltip>
                                            <v-spacer/>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <vue-excel-xlsx
                                                        :data="invitationsSent"
                                                        :columns="headersRecievedExcel"
                                                        :filename="'invitationsSentFromCompany' + '_' + date + '_' + date2"
                                                        :sheetname="$t('headerInvitationSentExcel')"
                                                    >
                                                        <v-btn
                                                                color="primary"
                                                                dark
                                                                v-on="on"
                                                                icon
                                                                :loading="loadingReportExcel">
                                                            <v-icon>description</v-icon>
                                                        </v-btn>
                                                    </vue-excel-xlsx>
                                                </template>
                                                <span>{{$t('export_to_excel')}}</span>
                                            </v-tooltip>
                                        </v-list-tile-avatar>
                                    </v-list-tile>
                                    <v-list-tile avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{$t('headerAccess')}}</v-list-tile-title>
                                        </v-list-tile-content>
                                        <v-list-tile-avatar>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        color="primary"
                                                        dark
                                                        v-on="on"
                                                        icon
                                                        :loading="loadingReportPDFAccess"
                                                        @click="exportPdfAccess">
                                                        <v-icon>picture_as_pdf</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{$t('download_to_pdf')}}</span>
                                            </v-tooltip>
                                            <v-spacer/>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <vue-excel-xlsx
                                                        :data="access"
                                                        :columns="headersAccessExcel"
                                                        :filename="'accessFromCompany' + '_' + date + '_' + date2"
                                                        :sheetname="$t('headerAccessExcel')"
                                                    >
                                                        <v-btn
                                                                color="primary"
                                                                dark
                                                                v-on="on"
                                                                icon
                                                                :loading="loadingReportExcelAccess">
                                                            <v-icon>description</v-icon>
                                                        </v-btn>
                                                    </vue-excel-xlsx>
                                                </template>
                                                <span>{{$t('export_to_excel')}}</span>
                                            </v-tooltip>
                                        </v-list-tile-avatar>
                                    </v-list-tile>
                                    <v-list-tile avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{$t('headerAccessNoCode')}}</v-list-tile-title>
                                        </v-list-tile-content>
                                        <v-list-tile-avatar>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        color="primary"
                                                        dark
                                                        v-on="on"
                                                        icon
                                                        :loading="loadingReportPDFAccessNoCode"
                                                        @click="exportPdfAccessNoCode">
                                                        <v-icon>picture_as_pdf</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{$t('download_to_pdf')}}</span>
                                            </v-tooltip>
                                            <v-spacer/>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <vue-excel-xlsx
                                                        :data="access_no_code"
                                                        :columns="headersAccessExcel"
                                                        :filename="'accessNoCodeFromCompany' + '_' + date + '_' + date2"
                                                        :sheetname="$t('headerAccessNoCodeExcel')"
                                                    >
                                                        <v-btn
                                                                color="primary"
                                                                dark
                                                                v-on="on"
                                                                icon
                                                                :loading="loadingReportExcelAccessNoCode">
                                                            <v-icon>description</v-icon>
                                                        </v-btn>
                                                    </vue-excel-xlsx>
                                                </template>
                                                <span>{{$t('export_to_excel')}}</span>
                                            </v-tooltip>
                                        </v-list-tile-avatar>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-layout align-center justify-center fill-height>
                <v-dialog v-model="dialog" persistent max-width="600px">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on " @click="update = false, clean_fields()"> + {{$t('AnadirEmpresa')}}</v-btn>
                    </template>
                    <v-form
                            @submit.prevent="update ? updateEmpresa(id_update) : altaEmpresa()">
                        <v-card class="elevation-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>
                                    {{$t('Empresas')}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                        class="align-self-end"
                                        color="red"
                                        icon
                                        @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                v-model="name"
                                                v-if="dialog" autofocus
                                                prepend-icon="business"
                                                name="name"
                                                :label="$t('nombre')"
                                                :error-messages="errores.name"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                v-model="address"
                                                prepend-icon="location_on"
                                                name="address"
                                                :label="$t('direccion')"
                                                :error-messages="errores.address"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                v-model="telephone"
                                                prepend-icon="phone"
                                                name="telephone"
                                                :label="$t('telefono')"
                                                :error-messages="errores.telephone"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                v-model="email"
                                                prepend-icon="email"
                                                name="email"
                                                label="E-Mail"
                                                :error-messages="errores.email"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <!--                                            <v-text-field-->
                                        <!--                                                    v-model="logo"-->
                                        <!--                                                    prepend-icon="score"-->
                                        <!--                                                    name="logo"-->
                                        <!--                                                    :label="$t('logotipo')"-->
                                        <!--                                                    :error-messages="errores.logo"-->
                                        <!--                                            ></v-text-field>-->
                                        <v-img
                                                :src="logo_imageUrl"
                                                v-if="logo_imageUrl"
                                                height="70"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <v-text-field
                                                v-model='logo'
                                                prepend-icon='attach_file'
                                                :label="$t('logotipo')"
                                                @click='pickFile_logo'
                                                :error-messages="errores.logo"
                                        ></v-text-field>
                                        <input
                                                type="file"
                                                style="display: none"
                                                ref="image_logo"
                                                accept="image/*"
                                                @change="onFilePicked_logo"
                                        >
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                v-model="web_page"
                                                prepend-icon="public"
                                                name="web_page"
                                                :label="$t('pagina_web')"
                                                :error-messages="errores.web_page"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                v-model="url_map"
                                                prepend-icon="http"
                                                name="url_map"
                                                :label="$t('url_mapa')"
                                                :error-messages="errores.url_map"
                                        ></v-text-field>
                                        <!--                                            <v-text-field-->
                                        <!--                                                    v-model="scian"-->
                                        <!--                                                    prepend-icon="looks_4"-->
                                        <!--                                                    name="scian"-->
                                        <!--                                                    label="SCIAN"-->
                                        <!--                                                    :error-messages="errores.scian"-->
                                        <!--                                            ></v-text-field>-->
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                v-model="classification"
                                                prepend-icon="class"
                                                name="classification"
                                                :label="$t('clasificacion')"
                                                :error-messages="errores.classification"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <!--                                    <v-layout row wrap>-->
                                <!--                                        <v-flex xs12 sm4>-->
                                <!--                                            <v-text-field-->
                                <!--                                                    v-model="latitude"-->
                                <!--                                                    prepend-icon="my_location"-->
                                <!--                                                    name="latitude"-->
                                <!--                                                    :label="$t('latitud')"-->
                                <!--                                                    :error-messages="errores.latitude"-->
                                <!--                                            ></v-text-field>-->
                                <!--                                        </v-flex>-->
                                <!--                                        <v-flex xs12 sm4>-->
                                <!--                                            <v-text-field-->
                                <!--                                                    v-model="longitude"-->
                                <!--                                                    prepend-icon="my_location"-->
                                <!--                                                    name="longitude"-->
                                <!--                                                    :label="$t('longitud')"-->
                                <!--                                                    :error-messages="errores.longitude"-->
                                <!--                                            ></v-text-field>-->
                                <!--                                        </v-flex>-->
                                <!--                                        <v-flex xs12 sm4>-->
                                <!--                                            <v-text-field-->
                                <!--                                                    v-model="url_map"-->
                                <!--                                                    prepend-icon="http"-->
                                <!--                                                    name="url_map"-->
                                <!--                                                    :label="$t('url_mapa')"-->
                                <!--                                                    :error-messages="errores.url_map"-->
                                <!--                                            ></v-text-field>-->
                                <!--                                        </v-flex>-->
                                <!--                                    </v-layout>-->
                                <v-layout row wrap>
                                    <v-flex xs12 sm3>
                                        <v-flex>
                                            <v-menu
                                                    v-model="calendario"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="validity"
                                                            prepend-icon="event"
                                                            name="validity"
                                                            :label="$t('vigencia')"
                                                            readonly
                                                            v-on="on"
                                                            :error-messages="errores.validity"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        v-model="validity"
                                                        :min="get_current_date()"
                                                        locale="es-MX"
                                                        @input="calendario = false">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs12 sm5>
                                        <v-autocomplete
                                                v-model="id_parque"
                                                prepend-icon="location_city"
                                                name="id_parque"
                                                item-text="nombre"
                                                item-value="id"
                                                :label="$t('Parque')"
                                                :filter="customFilter"
                                                :error-messages="errores.id_parque"
                                                :items="parques"
                                                no-data-text="Ningún Resultado"
                                                clearable
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <v-text-field
                                            v-model="numPiso"
                                            prepend-icon="elevator"
                                            :label="$t('num_piso')"
                                            :error-messages="errores.numPiso"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                                <v-spacer/>
                                <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                                <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-layout>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('Empresas')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_empresas"
                            :items="empresas"
                            :search="search"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        medium
                                        class="mr-2"
                                        @click="fill_fields(props.item), update = true, dialog = true, id_update = props.item.id"
                                >
                                    edit
                                </v-icon>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                                medium
                                                class="mr-2"
                                                v-on="on"
                                                @click="fecha_actual = get_current_date2(), date = fecha_actual, date2 = fecha_actual, id_update = props.item.id, companyName = props.item.name, submit(), dialogReport = true"
                                        >
                                            text_snippet
                                        </v-icon>
                                    </template>
                                    <span>{{$t('headerInvitationSent')}}</span>
                                </v-tooltip>
                            </td>
                            <td align="center">
                                <v-btn
                                    v-if="props.item.enabled === true"
                                    dark
                                    color="red"
                                    @click="dialogEnableDisable = true, disable = true, enable = false, id_update = props.item.id"
                                >
                                    {{$t('desactivar')}}
                                </v-btn>
                                <v-btn
                                        v-else
                                        color="primary"
                                        @click="dialogEnableDisable = true, disable = false, enable = true, id_update = props.item.id"
                                >
                                    {{$t('activar')}}
                                </v-btn>
                            </td>
                            <td align="center">
                                <v-btn
                                    v-if="props.item.can_send === true"
                                    dark
                                    color="red"
                                    @click="dialogEnableDisableInvitation = true, disableInvitation = true, enableInvitation = false, id_update = props.item.id"
                                >
                                    {{$t('desactivar')}}
                                </v-btn>
                                <v-btn
                                        v-else
                                        dark
                                        color="green"
                                        @click="dialogEnableDisableInvitation = true, disableInvitation = false, enableInvitation = true, id_update = props.item.id"
                                >
                                    {{$t('activar')}}
                                </v-btn>
                            </td>
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.address }}</td>
                            <td>{{ props.item.telephone }}</td>
                            <td>{{ props.item.email }}</td>
                            <td>
                                <v-img :src="props.item.logo">
                                </v-img>
                            </td>
                            <td>{{ props.item.web_page }}</td>
                            <td>{{ props.item.scian }}</td>
                            <td>{{ props.item.classification }}</td>
                            <td>{{ props.item.latitude }}</td>
                            <td>{{ props.item.longitude }}</td>
                            <td>{{ props.item.url_map }}</td>
                            <td>{{ props.item.validity }}</td>
                            <td>{{ props.item.id_parque }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import jsPDF from 'jspdf'
    import 'jspdf-autotable'

    Vue.use(VeeValidate)
    import { mapState} from 'vuex'

    export default {
        name: "empresas",
        data: () => ({
            alerta: false,
            calendario: false,
            parques: [],
            administradores: [],
            empresas: [],
            dialog: false,
            update:false,
            id_update: 0,
            companyName: 0,
            name: '',
            address: '',
            telephone:'',
            email: '',
            logo: '',
            web_page: '',
            scian: '',
            classification: '',
            latitude: '',
            longitude: '',
            url_map: '',
            validity: '',
            id_parque: '',
            numPiso: null,
            errores: [],
            search: '',
            headers: [],
            loading_data_empresas: false,
            logo_imageUrl: '',
            logo_imageName: '',
            logo_imageFile: '',
            loading: false,
            dialogReport:false,
            calendario2: false,
            calendario3: false,
            fecha_actual: '',
            date: '',
            date2: '',
            yyyy: '',
            mm: '',
            dd: '',
            yyyy2: '',
            mm2: '',
            dd2: '',
            loadingReportPDF: false,
            loadingReportExcel: false,
            loadingReportPDFAccess: false,
            loadingReportExcelAccess: false,
            loadingReportPDFAccessNoCode: false,
            loadingReportExcelAccessNoCode: false,
            invitationsSent: '',
            headersRecievedExcel: [],
            headersAccessExcel: [],
            access: '',
            access_no_code: '',
            dialogEnableDisable: false,
            disable: false,
            enable: false,
            loadingEnableDisable: false,
            dialogEnableDisableInvitation: false,
            disableInvitation: false,
            enableInvitation: false,
            loadingEnableDisableInvitation: false
        }),
        beforeUpdate(){
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'left',
                    sortable: false,
                    value: 'actions'
                },
                {
                    text: this.$t('activar_desactivar'),
                    align: 'center',
                    sortable: true,
                    value: 'enabled'
                },
                {
                    text: this.$t('puede_enviar2'),
                    align: 'center',
                    sortable: true,
                    value: 'can_send'
                },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: this.$t('direccion'),
                    align: 'left',
                    sortable: true,
                    value: 'address'
                },
                {
                    text: this.$t('telefono'),
                    align: 'left',
                    sortable: true,
                    value: 'telephone'
                },
                {
                    text: 'E-Mail',
                    align: 'left',
                    sortable: true,
                    value: 'email'
                },
                {
                    text: this.$t('logotipo'),
                    align: 'left',
                    sortable: true,
                    value: 'logo'
                },
                {
                    text: this.$t('pagina_web'),
                    align: 'left',
                    sortable: true,
                    value: 'web_page'
                },
                {
                    text: 'SCIAN',
                    align: 'left',
                    sortable: true,
                    value: 'scian'
                },
                {
                    text: this.$t('clasificacion'),
                    align: 'left',
                    sortable: true,
                    value: 'classification'
                },
                {
                    text: this.$t('latitud'),
                    align: 'left',
                    sortable: true,
                    value: 'latitude'
                },
                {
                    text: this.$t('longitud'),
                    align: 'left',
                    sortable: true,
                    value: 'longitude'
                },
                {
                    text: this.$t('url_mapa'),
                    align: 'left',
                    sortable: true,
                    value: 'url_map'
                },
                {
                    text: this.$t('vigencia'),
                    align: 'left',
                    sortable: true,
                    value: 'validity'
                },
                {
                    text: 'ID_Parque',
                    align: 'left',
                    sortable: true,
                    value: 'id_parque'
                }
            ],
            this.headersRecievedExcel = [
                {
                    label: this.$t('Anfitrion'),
                    field: 'host'
                },
                {
                    label: this.$t('Visitante'),
                    field: 'guest'
                },
                {
                    label:this.$t('fecha_hora'),
                    field: 'date_time_sent',
                    dataFormat: this.dateFormat
                }
            ],
            this.headersAccessExcel = [
                {
                    label: this.$t('Anfitrion'),
                    field: 'host'
                },
                {
                    label: this.$t('Visitante'),
                    field: 'guest'
                },
                {
                    label:this.$t('hora_acceso'),
                    field: 'date_time_entrance_access',
                    dataFormat: this.dateFormat
                },
                {
                    label:this.$t('hora_salida'),
                    field: 'date_time_exit_access',
                    dataFormat: this.dateFormat
                }
            ]
        },
        created: function () {
            this.get_parques()
            this.get_empresas()
        },
        computed: {
            ...mapState(['language']),
            computedInitialDateFormatted () {
                return this.formatDate(this.date)
            },
            computedFinalDateFormatted () {
                return this.formatDate(this.date2)
            }
        },
        methods: {
            dateFormat(value){
                if (value !== null) {
                    const [year, month, day] = value.split('-')
                    const [dia, hora] = day.split(' ')
                    // console.log(dia, hora)
                    return `${dia}/${month}/${year} ${hora}`
                }
                else return ''
            },
            get_parques(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/parques/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.parques = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_empresas: function(){
                this.loading_data_empresas = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.empresas = response.data
                        this.loading_data_empresas = false
                    })
                    .catch(error => {
                        this.loading_data_empresas = false
                        console.log(error)
                    })
            },
            exportPdfInvitationSent () {
                this.loadingReportPDF = true
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerInvitationSent = this.$t('headerInvitationSent')
                var nombreEmpresa = this.$t('Empresa') + ': ' + this.companyName
                var total = 'Total: ' + this.invitationsSent.length.toString()
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var columns = [{
                    host: this.$t('Anfitrion'),
                    guest: this.$t('Visitante'),
                    date_time_sent: this.$t('fecha_hora_envio')
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.invitationsSent,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerInvitationSent, data.settings.margin.left + 20, 38)
                        doc.text(nombreEmpresa, data.settings.margin.left + 20, 60)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 82)
                        doc.text(total, data.settings.margin.left + 20, 104)

                        // Footer
                        var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        if (typeof doc.putTotalPages === 'function') {
                            str = str + de + totalPagesExp
                        }
                        doc.setFontSize(10)
                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.column.index === 2) {
                            if (data.row.section === 'body') {
                                const [year, month, day] = data.cell.text.toString().split('-')
                                const [dia, hora] = day.split(' ')
                                // console.log(dia, hora)
                                data.cell.text = `${dia}/${month}/${year} ${hora}`
                            }
                        }
                    },
                    margin: { top: 120 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('invitationsSent' + '_' + this.date + '_' + this.date2 + '.pdf')
                this.loadingReportPDF = false
            },
            exportPdfAccess () {
                this.loadingReportPDFAccess = true
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerInvitationSent = this.$t('headerAccess')
                var nombreEmpresa = this.$t('Empresa') + ': ' + this.companyName
                var total = 'Total: ' + this.access.length.toString()
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var columns = [{
                    host: this.$t('Anfitrion'),
                    guest: this.$t('Visitante'),
                    date_time_entrance_access: this.$t('hora_acceso'),
                    date_time_exit_access: this.$t('hora_salida')
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.access,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerInvitationSent, data.settings.margin.left + 20, 38)
                        doc.text(nombreEmpresa, data.settings.margin.left + 20, 60)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 82)
                        doc.text(total, data.settings.margin.left + 20, 104)

                        // Footer
                        var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        if (typeof doc.putTotalPages === 'function') {
                            str = str + de + totalPagesExp
                        }
                        doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.column.index === 2 || data.column.index === 3) {
                            if (data.row.section === 'body') {
                                if(data.cell.text.toString() !== '') {
                                    const [year, month, day] = data.cell.text.toString().split('-')
                                    const [dia, hora] = day.split(' ')
                                    // console.log(dia, hora)
                                    data.cell.text = `${dia}/${month}/${year} ${hora}`
                                }
                                else {
                                     data.cell.text = ""
                                }
                            }
                        }
                    },
                    margin: { top: 120 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('access' + '_' + this.date + '_' + this.date2 + '.pdf')
                this.loadingReportPDFAccess = false
            },
            exportPdfAccessNoCode () {
                this.loadingReportPDFAccessNoCode = true
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerInvitationSent = this.$t('headerAccessNoCode')
                var nombreEmpresa = this.$t('Empresa') + ': ' + this.companyName
                var total = 'Total: ' + this.access_no_code.length.toString()
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var columns = [{
                    guest: this.$t('Visitante'),
                    date_time_entrance_access: this.$t('hora_acceso'),
                    date_time_exit_access: this.$t('hora_salida')
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.access_no_code,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerInvitationSent, data.settings.margin.left + 20, 38)
                        doc.text(nombreEmpresa, data.settings.margin.left + 20, 60)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 82)
                        doc.text(total, data.settings.margin.left + 20, 104)

                        // Footer
                        var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        if (typeof doc.putTotalPages === 'function') {
                            str = str + de + totalPagesExp
                        }
                        doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.column.index === 1 || data.column.index === 2) {
                            if (data.row.section === 'body') {
                                if(data.cell.text.toString() !== '') {
                                    const [year, month, day] = data.cell.text.toString().split('-')
                                    const [dia, hora] = day.split(' ')
                                    // console.log(dia, hora)
                                    data.cell.text = `${dia}/${month}/${year} ${hora}`
                                }
                                else {
                                     data.cell.text = ""
                                }
                            }
                        }
                    },
                    margin: { top: 120 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('accessNoCode' + '_' + this.date + '_' + this.date2 + '.pdf')
                this.loadingReportPDFAccessNoCode = false
            },
            altaEmpresa: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        this.errores = []
                        console.log('Valor Num de Piso = ', this.numPiso)
                        var numPisoAux = this.numPiso === null ? '' : this.numPiso.toString().trim()
                        if (this.id_parque == null)
                            this.id_parque = ''
                        var bodyFormData = new FormData()

                        bodyFormData.set('name', this.name)
                        bodyFormData.set('address', this.address)
                        bodyFormData.set('telephone', this.telephone)
                        bodyFormData.set('email', this.email.toLowerCase())
                        bodyFormData.append('logo', this.logo_imageFile)
                        bodyFormData.set('web_page', this.web_page)
                        bodyFormData.set('scian', 1)
                        bodyFormData.set('classification', this.classification)
                        bodyFormData.set('latitude', 2)
                        bodyFormData.set('longitude', 2)
                        bodyFormData.set('url_map', this.url_map)
                        bodyFormData.set('validity', this.validity)
                        bodyFormData.set('id_parque', this.id_parque)
                        bodyFormData.set('numPiso', numPisoAux)
                        bodyFormData.set('enabled', true)
                        bodyFormData.set('can_send', true)
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/empresas/',
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: bodyFormData
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_empresa_alta'))
                                this.dialog = false
                                this.get_empresas()
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loading = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });

            },
            updateEmpresa(id){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        this.errores = []
                        var numPisoAux = this.numPiso === null ? '' : this.numPiso.toString().trim()
                        if (this.id_parque == null)
                            this.id_parque = ''
                        var bodyFormData = new FormData()

                        bodyFormData.set('name', this.name)
                        bodyFormData.set('address', this.address)
                        bodyFormData.set('telephone', this.telephone)
                        bodyFormData.set('email', this.email.toLowerCase())
                        bodyFormData.append('logo', this.logo_imageFile)
                        bodyFormData.set('web_page', this.web_page)
                        bodyFormData.set('scian', 1)
                        bodyFormData.set('classification', this.classification)
                        bodyFormData.set('latitude', 2)
                        bodyFormData.set('longitude', 2)
                        bodyFormData.set('url_map', this.url_map)
                        bodyFormData.set('validity', this.validity)
                        bodyFormData.set('id_parque', this.id_parque)
                        bodyFormData.set('numPiso', numPisoAux)
                        const config = {
                            method: 'patch',
                            url: 'https://empresa-service.intrare.app/empresas/'+ id +'/update/',
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: bodyFormData
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                console.log(this.id_parque)
                                this.get_empresas()
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_empresa_modificado'))
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loading = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            },
            fill_fields(item){
                this.name = item.name
                this.address = item.address
                this.telephone = item.telephone
                this.email = item.email
                this.logo = item.logo
                this.logo_imageUrl = item.logo
                this.web_page = item.web_page
                this.scian = item.scian
                this.classification = item.classification
                this.latitude = item.latitude
                this.longitude = item.longitude
                this.url_map = item.url_map
                this.validity = item.validity
                this.id_parque = item.id_parque
                this.numPiso = item.numPiso
            },
            customFilter (item, queryText) {
                const textOne = item.nombre.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            clean_fields(){
                this.name = ""
                this.address = ""
                this.telephone = ""
                this.email = ""
                this.logo = ""
                this.web_page = ""
                this.scian = ""
                this.classification = ""
                this.latitude = ""
                this.longitude = ""
                this.url_map = ""
                this.validity = ""
                this.id_parque = ""
                this.logo_imageUrl = ''
                this.logo_imageName = ''
                this.logo_imageFile = ''
                this.numPiso = null
            },
            get_current_date: function (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            get_current_date2: function (){
                var today = new Date();
                this.dd = today.getDate();
                this.mm = today.getMonth()+1;
                this.yyyy = today.getFullYear();
                this.dd2 = today.getDate();
                this.mm2 = today.getMonth()+1;
                this.yyyy2 = today.getFullYear();

                if(this.dd<10)
                {
                    this.dd='0'+this.dd;
                }
                if(this.dd2<10)
                {
                    this.dd2='0'+this.dd2;
                }

                if(this.mm<10)
                {
                    this.mm='0'+this.mm;
                }
                if(this.mm2<10)
                {
                    this.mm2='0'+this.mm2;
                }
                today = this.yyyy + '-' + this.mm + '-' + this.dd;
                return today
            },
            split_date: function(date, date2){
                var arr = date.split('-')
                var arr2 = date2.split('-')

                this.yyyy = arr[0]
                this.mm = arr[1]
                this.dd = arr[2 ]

                this.yyyy2 = arr2[0]
                this.mm2 = arr2[1]
                this.dd2 = arr2[2 ]
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            submit () {
                this.split_date(this.date, this.date2)
                const config = {
                    method: 'GET',
                    url: 'https://empresa-service.intrare.app/Reports/pull_data/invitation/' + this.id_update + '/' + this.yyyy + '/'  + this.mm + '/' + this.dd + '/' + this.yyyy2 + '/'  + this.mm2 + '/' + this.dd2 + '/',
                    headers: {
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.invitationsSent = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
                const config2 = {
                    method: 'GET',
                    url: 'https://empresa-service.intrare.app/Reports/pull_data/_acces_code/' + this.id_update + '/' + this.yyyy + '/'  + this.mm + '/' + this.dd + '/' + this.yyyy2 + '/'  + this.mm2 + '/' + this.dd2 + '/',
                    headers: {
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config2)
                    .then(response => {
                        this.access = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
                const config3 = {
                    method: 'GET',
                    url: 'https://empresa-service.intrare.app/Reports/pull_data/_acces_no_code/' + this.id_update + '/' + this.yyyy + '/'  + this.mm + '/' + this.dd + '/' + this.yyyy2 + '/'  + this.mm2 + '/' + this.dd2 + '/',
                    headers: {
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config3)
                    .then(response => {
                        this.access_no_code = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            pickFile_logo () {
                this.$refs.image_logo.click ()
            },
            onFilePicked_logo (e) {
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.logo_imageName = files[0].name
                    if(this.logo_imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.logo_imageUrl = fr.result
                        this.logo_imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.logo_imageName = ''
                    this.logo_imageFile = ''
                    this.logo_imageUrl = ''
                }
            },
            enableDisableCompany () {
                if (this.enable === true) {
                    this.loadingEnableDisable = true
                    console.log('Activa Todos los Usuarios')
                    const config = {
                        method: 'patch',
                        url: 'https://empresa-service.intrare.app/empresas/' + this.id_update + '/change_status/',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: {
                            enabled: true
                        }
                    }
                    axios(config)
                        .then(ok => {
                            this.loadingEnableDisable = false
                            console.log(ok)
                            this.get_empresas()
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_activados'))
                            this.dialogEnableDisable = false
                            setTimeout(this.clear, 3000)
                        })
                        .catch(error => {
                            this.loadingEnableDisable = false
                            console.log(error)
                        })
                } else {
                    if (this.disable === true) {
                        this.loadingEnableDisable = true
                        console.log('Desactiva Todos los Usuarios')
                        const config = {
                            method: 'patch',
                            url: 'https://empresa-service.intrare.app/empresas/' + this.id_update + '/change_status/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                enabled: false
                            }
                        }
                        axios(config).then(ok => {
                            this.loadingEnableDisable = false
                            console.log(ok)
                            this.get_empresas()
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_color', 'warning')
                            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_desactivados'))
                            this.dialogEnableDisable = false
                            setTimeout(this.clear, 3000)
                        })
                            .catch(error => {
                                this.loadingEnableDisable = false
                                console.log(error)
                            })
                    }
                }
            },
            enableDisableInvitationCompany () {
                if (this.enableInvitation === true) {
                    this.loadingEnableDisableInvitation = true
                    console.log('Activa Todos los Usuarios')
                    const config = {
                        method: 'patch',
                        url: 'https://empresa-service.intrare.app/empresas/enable/' + this.id_update + '/cansend/all/',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: {}
                    }
                    axios(config)
                        .then(ok => {
                            this.loadingEnableDisableInvitation = false
                            console.log(ok)
                            this.get_empresas()
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_activados'))
                            this.dialogEnableDisableInvitation = false
                            setTimeout(this.clear, 3000)
                        })
                        .catch(error => {
                            this.loadingEnableDisableInvitation = false
                            console.log(error)
                        })
                } else {
                    if (this.disableInvitation === true) {
                        this.loadingEnableDisableInvitation = true
                        console.log('Desactiva Todos los Usuarios')
                        const config = {
                            method: 'patch',
                            url: 'https://empresa-service.intrare.app/empresas/disable/' + this.id_update + '/cansend/all/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {}
                        }
                        axios(config).then(ok => {
                            this.loadingEnableDisableInvitation = false
                            console.log(ok)
                            this.get_empresas()
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_color', 'warning')
                            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_desactivados'))
                            this.dialogEnableDisableInvitation = false
                            setTimeout(this.clear, 3000)
                        })
                            .catch(error => {
                                this.loadingEnableDisableInvitation = false
                                console.log(error)
                            })
                    }
                }
            },
        }
    }
</script>
